// Audio announcement language — reads the same localStorage key the rest of
// the app uses ("audioLanguage"), defaulting to English.
export const getAudioLanguage = (): string =>
  localStorage.getItem("audioLanguage") || "en";

// The languages the backend TTS can actually speak. It keys both the voice and
// the sentence template off this code, and silently falls back to English for
// anything it doesn't know — so offering a longer list here would promise
// announcements we can't make. Keep in sync with the backend's
// textToSpeech/globals/ttsConstatnts.js.
export const ANNOUNCEMENT_LANGUAGES: ReadonlyArray<{
  code: string;
  label: string;
}> = [
  { code: "en", label: "English" },
  { code: "kn", label: "Kannada" },
  { code: "hi", label: "Hindi" },
  { code: "ta", label: "Tamil" },
  { code: "te", label: "Telugu" },
];

export const isAnnouncementLanguage = (v: unknown): v is string =>
  typeof v === "string" && ANNOUNCEMENT_LANGUAGES.some((l) => l.code === v);
